import React from 'react';
import { Link } from 'react-router-dom';


export default function About() {
return (
<section className="py-5 bg-gray-50">
<div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
<img src="/images/aboutus/aboutus.jpg" alt="About Us" className="rounded shadow" />
<div>
<h2 className="text-3xl font-bold mb-4">About Us</h2>
<p className="mb-4">We are a contemporary company dedicated to delivering high-quality services with innovation, creativity and professionalism. Our goal is to deliver impactful solutions that enable businesses to grow and succeed in today’s competitive world.</p>
<p className="mb-4">With a passionate team and years of experience, we focus on building strong relationships with our clients and ensuring that every project meets the highest standards.</p>
<Link to="/about">
<button className="bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition">Learn More</button>
</Link>
</div>
</div>
</section>
);
}